import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["list", "listResponsive", "listHeader", "chevronDown", "chevronUp"];

  declare listTarget: HTMLElement;
  declare hasListTarget: boolean;
  declare listResponsiveTarget: HTMLElement;
  declare hasListResponsiveTarget: boolean;
  declare listHeaderTarget: HTMLElement;
  declare hasListHeaderTarget: boolean;
  declare chevronDownTarget: HTMLSpanElement;
  declare hasChevronDownTarget: boolean;
  declare chevronUpTarget: HTMLSpanElement;
  declare hasChevronUpTarget: boolean;

  connect() {
    const main = document.getElementById("main");
    if (main && this.hasListHeaderTarget) {
      main.addEventListener("click", () => {
        this.listHeaderTarget.classList.add("hidden");
      });
    }
  }

  toggle() {
    if (this.hasListTarget) {
      this.listTarget.classList.toggle("hidden");
      this.toggleChevrons(this.listTarget);
    }
  }

  toggleResponsive() {
    if (this.hasListResponsiveTarget) {
      this.listResponsiveTarget.classList.toggle("hidden");
      this.toggleChevrons(this.listResponsiveTarget);
    }
  }

  toggleHeader() {
    if (this.hasListHeaderTarget) {
      this.listHeaderTarget.classList.toggle("hidden");
    }
  }

  toggleChevrons(dropdownTarget) {
    if (this.hasChevronDownTarget && this.hasChevronUpTarget) {
      console.log(this.hasChevronDownTarget);
      if (dropdownTarget.classList.contains("hidden")) {
        this.chevronDownTarget.classList.remove("hidden");
        this.chevronUpTarget.classList.add("hidden");
      } else {
        this.chevronDownTarget.classList.add("hidden");
        this.chevronUpTarget.classList.remove("hidden");
      }
    }
  }
}
